export const FINANCE_LAST_PERIOD = 'last';
export const FINANCE_PERIOD_SHORT_MAX_WIDTH = 640;

export type FinancePeriodOption = {
  value: string;
  label: string;
  shortLabel: string;
};

export const financePeriodOptions = (
  years: Array<{ year: number } | number> = [],
  capitalize = false
): FinancePeriodOption[] => {
  const lead = capitalize ? 'За' : 'за';
  const yearsOnly = years.map((item) =>
    typeof item === 'number' ? item : item.year
  );
  const values = yearsOnly
    .filter((year, index) => yearsOnly.indexOf(year) === index)
    .sort((a, b) => b - a);
  return [
    {
      value: FINANCE_LAST_PERIOD,
      label: `${lead} последний`,
      shortLabel: `${lead} посл.`,
    },
    ...values.map((year) => ({
      value: String(year),
      label: `${lead} ${year} год`,
      shortLabel: `${lead} ${year} г.`,
    })),
  ];
};

export const financePeriodOptionText = (
  option: FinancePeriodOption,
  short: boolean
) => (short ? option.shortLabel : option.label);
